import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import Box from "@mui/material/Box";
import QuoteBackup from "./QuoteBackupAndTransfer/QuoteBackup";
import QuoteDeletionReport from "../Components/QuoteCompare/QuoteDeletionReport";
import axios from "axios";
import { baseUrl } from "../Services/Constants";
import { processAndUpdateToken } from "../Services/CommonFunctions";
import { useEffect } from "react";

const QuoteAdminAccess = () => {
  const [activeTab, setActiveTab] = useState("table1");
  const [qcConfig, setQcConfig] = useState("");
  const [qcDeletionConfig, setQcDeletionConfig] = useState("");
  useEffect(() => {
    getUserRole();
  }, []);

  const getUserRole = async () => {
    const token = sessionStorage.getItem("token");
    const userName = sessionStorage.getItem("userName");

    const updatedToken = await processAndUpdateToken(token);
    const response = await axios.get(
      `${baseUrl}/api/Defaultdatum/GetUserRole?userName=${userName}`,
      {
        headers: {
          Authorization: `Bearer ${updatedToken}`,
        },
      }
    );
    const config = response?.data;
    const deletionConfig = response.data.QcDeletionConfig || "";

    setQcConfig(config);
    setQcDeletionConfig(deletionConfig);

    if (config?.QcConfig?.includes("table1")) {
      setActiveTab("table1");
    } else if (config?.QcConfig?.includes("table2")) {
      setActiveTab("table2");
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };


  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="app-container">
          <div style={{ padding: "5px", width: "95%" }}>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
              >
                {/* Backup Tab */}
                {(qcConfig?.QcConfig?.includes("table1") || qcConfig?.IsQcGlobalAdmin) && (
                  <Tab
                    label="BackUp Records"
                    value="table1"
                  />
                )}

                {/* Deletion Tab with condition */}
                {(qcConfig?.QcConfig?.includes("table2") || qcConfig?.IsQcGlobalAdmin) && (
                  <Tab
                    label="Deletion Report"
                    value="table2"
                  />
                )}
              </Tabs>
            </Box>
            <div>
              {activeTab === "table1" &&
                (qcConfig?.QcConfig?.includes("table1") || qcConfig?.IsQcGlobalAdmin) && (
                  <QuoteBackup />
                )}

              {activeTab === "table2" && (qcConfig?.QcConfig?.includes("table2") || qcConfig?.IsQcGlobalAdmin) && (
                <QuoteDeletionReport activeTab={activeTab} />
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteAdminAccess;